import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ShoppingCart from './pages/shopping-cart';
import ProductCatalog from './pages/product-catalog';
import AdminDashboard from './pages/admin-dashboard';
import RFQManagement from './pages/rfq-management';
import LoginPage from './pages/login';
import OrderHistory from './pages/order-history';
import RFQRequestForm from './pages/rfq-request-form';
import CustomerDashboard from './pages/customer-dashboard';
import RFQProcessing from './pages/rfq-processing';
import Register from './pages/register';
import ServiceDetailsPage from './pages/service-details';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<AdminDashboard />} />
        <Route path="/shopping-cart" element={<ShoppingCart />} />
        <Route path="/product-catalog" element={<ProductCatalog />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/rfq-management" element={<RFQManagement />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/order-history" element={<OrderHistory />} />
        <Route path="/rfq-request-form" element={<RFQRequestForm />} />
        <Route path="/customer-dashboard" element={<CustomerDashboard />} />
        <Route path="/rfq-processing" element={<RFQProcessing />} />
        <Route path="/register" element={<Register />} />
        <Route path="/service-details" element={<ServiceDetailsPage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
